/**
 * Library Error.
 */
class LibraryError extends Error {
  /**
   * Constructor.
   * @param {Symbol} code - The error code.
   * @param {string} message - The error message.
   * @param {string} [data] - The error data (optional).
   */
  constructor(code, message, data = undefined) {
    super(message);
    this.name = 'LibraryError';
    this.code = code;
    this.data = data;
  }
}

module.exports = LibraryError;
